/* eslint-disable react-hooks/exhaustive-deps */
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField"
import { useEffect } from "react"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { defaultPrimitive, ILandingPrimitive, ImageCardField } from "src/modules/pe-landing-module/data/interfaces"
import { ImagePrimitive } from "../../primitive"

const CardFieldImage = (props: ICardFieldProps): JSX.Element => { 
    const { value, section, contentData, i } = props 
    const id = contentData?.id || section.id
    const field: ImageCardField = props.field as ImageCardField
    const width =  field.style?.width || value.style?.width  
    const height =  field.style?.height || value.style?.height 
    useEffect(() => {
        //            
        addCSSClass(
            `landing-card-field-image-${id + "-" + value.id}`,
            `.landing-card-field-image-${id + "-" + value.id} {
                --height: ${height}!important;
                max-height: ${height}!important;
                --background-image: url(${value?.data});
            } 
            `
        )
        return () => removeCSSClass(`landing-card-field-image-${id + "-" + value.id}`)
    }, [])
    
    const primitive: ILandingPrimitive = {
        ...defaultPrimitive(),
        ...field,
        ...value, 
        data: {
            src_type: "div",
            ...field.data,
            src: value.data,
        },
        position: {
            width,
            height,
            aspect: parseInt(width?.toString() || "73") / parseInt(height?.toString() || "73")  
        },
        style: { ...field.style, ...value.style, minHeight: "100%", },
        className: (field.className || "") + " " + (value.style || "") + " medallion-padder",
        id: id + "-" + value?.id,
    } 
    
    return <div 
        className={`landing-card-field landing-card-field-image landing-card-field-image-${id + "-" + value.id} ${value.className || ""}`} 
        data-card-field-id={i} 
        card-field-section-id={id}
    >
        <ImagePrimitive 
            primitive={primitive as any}
        />
    </div>
}
export default CardFieldImage